export default "__VITE_ASSET__$_kUDnEI__"